import {EPA_FETCH_SUPPORTEDLIST,ERROR_CLOSE,EPA_FETCH_ACTIVEPARTNUMBERS,GETEXTRANODES_QTY,CONTROLLER_CONFIG,FILTERED_COMPONENTS,OSLISTBLUEDATA,SERVER_LIST,FETCH_DEFAULT_WRKLD,FETCH_NODEQTY,ARCVALUE,OSLIST,EPAVNEXT_FETCH_TEMPLATELIST,CALCULATEBLUEDATACONFIGFALSE,EPICREQUIREMENTS,CALCULATEBLUEDATACONFIG,FETCH_GATEWAYDLTS,CALC_DISABLED,FETCH_ANALYTICSDATABASENODEQTY,TENANTDRIVELIST, GATEWAY_RECOMMENDATIONS, CONTROLLER_RECOMMENDATIONS, MASTER_RECOMMENDATIONS} from '../action_types/epaActionTypes';
import {_serviceUrl,_said} from '../../SizerConfig/Config';



export const fetchSupportedList = () => ({
  type: 'API_REQUEST',
  payload: {
    url: _serviceUrl+ _said+'/GetAllSupportedComponents',    
    next: EPA_FETCH_SUPPORTEDLIST 
  }
});
export const fetchTemplateList = () => ({
  type: 'API_REQUEST',
  payload: {
    url: _serviceUrl+ _said+'/GetTemplates',    
    next: EPAVNEXT_FETCH_TEMPLATELIST 
  }
});

export const fetchActiveList = () => ({
  type: 'API_REQUEST',
  payload: {
    url: _serviceUrl+ _said+'/GetActivePartNumbers',    
    next: EPA_FETCH_ACTIVEPARTNUMBERS 
  }
});
export const fetchFilteredComps = (data) =>({
  type:FILTERED_COMPONENTS,
  payload:{data}  
});
export const errorclose=()=>({
  type:ERROR_CLOSE
})
export const controllerchnaged = (data) =>({
  type:CONTROLLER_CONFIG,
  payload:{data}  
});
export const Calbutn = (data) =>({
  type:CALC_DISABLED,
  payload:{data}  
});

export const fetchServerList = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    url: _serviceUrl+ _said+'/GetServersAndHardware',  
    data:data,  
    next: SERVER_LIST 
  }
});

export const defaultfetchServerList = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    url: _serviceUrl+_said+'/GetHardWareDefaults',  
    data:data,
    next: SERVER_LIST 
  }
});
export const onepicequirements = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    url: _serviceUrl+_said+'/GetEPICRequirements',  
    data:data,
    next: EPICREQUIREMENTS 
  }
});
export const fetchNodeQty = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    url: _serviceUrl+_said+'/NodeQty',  
    data:data,
    next:FETCH_NODEQTY 
  }
});
export const fetchDefaults = () => ({
  type: 'API_REQUEST',
  payload: {
    url: _serviceUrl+_said+'/',  
    next: FETCH_DEFAULT_WRKLD 
  }
});
export const getARCValue = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
     data:data,
    url: _serviceUrl+_said+'/GetARCValue',  
    next: ARCVALUE 
  }
});
export const getosdisklist = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    data:data,
    url: _serviceUrl+_said+'/GetOSDiskList',  
    next: OSLIST
  }
});
export const getosdisklistBlueData = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    data:data,
    url: _serviceUrl+_said+'/GetOSDiskList',  
    next: OSLISTBLUEDATA
  }
});

export const getTenantStorageDiskList = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    data:data,
    url: _serviceUrl+_said+'/GetOSDiskList',  
    next: TENANTDRIVELIST
  }
});


export const getextranodesqty = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    data:data,
    url: _serviceUrl+_said+'/GetExtraNodesQty',  
    next: GETEXTRANODES_QTY
  }
});
export const oncalbluedataconfigtrue = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    data:data,
    url: _serviceUrl+_said+'/CalculateBlueDataConfiguration',  
    next: CALCULATEBLUEDATACONFIG
  }
});
export const oncalbluedataconfigfalse = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    data:data,
    url: _serviceUrl+_said+'/CalculateBlueDataConfiguration',  
    next: CALCULATEBLUEDATACONFIGFALSE
  }
});
export const fetchgatewaydlts = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    data:data,
    url: _serviceUrl+_said+'/GetGatewayNodeDetails',  
    next: FETCH_GATEWAYDLTS 
  }
});
export const recallAnalyticsandDatabasenodeQty = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    data:data,
    url: _serviceUrl+_said+'/GetRecallNodeStorageCalc',  
    next: FETCH_ANALYTICSDATABASENODEQTY
  }
});

export const GetGatewayRecommendations = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    data: data,
    url : _serviceUrl+_said+'/GatewayAndControllerRecommendations',
    next: GATEWAY_RECOMMENDATIONS
  }
})

export const GetControllerRecommendations = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    data: data,
    url : _serviceUrl+_said+'/GatewayAndControllerRecommendations',
    next: CONTROLLER_RECOMMENDATIONS
  }
})

export const GetMasterRecommendations = (data) => ({
  type: 'API_REQUEST_POST',
  payload: {
    data: data,
    url : _serviceUrl+_said+'/GatewayAndControllerRecommendations',
    next: MASTER_RECOMMENDATIONS
  }
})






// WEBPACK FOOTER //
// ./src/SizerUI/Redux/actions/epaActions.js